var items = {
  "block.minecraft.air": "vzduch",
  "block.minecraft.stone": "kameň",
  "block.minecraft.granite": "žula",
  "block.minecraft.polished_granite": "leštená žula",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "leštený diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "leštený andezit",
  "block.minecraft.grass_block": "trávnik",
  "block.minecraft.dirt": "hlina",
  "block.minecraft.coarse_dirt": "hrubá hlina",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "karmínové podhubie",
  "block.minecraft.warped_nylium": "prízračné podhubie",
  "block.minecraft.cobblestone": "dlažobný kameň",
  "block.minecraft.oak_planks": "dubové dosky",
  "block.minecraft.spruce_planks": "smrekové dosky",
  "block.minecraft.birch_planks": "brezové dosky",
  "block.minecraft.jungle_planks": "džungľové dosky",
  "block.minecraft.acacia_planks": "akáciové dosky",
  "block.minecraft.dark_oak_planks": "dosky z tmavého dubu",
  "block.minecraft.crimson_planks": "karmínové dosky",
  "block.minecraft.warped_planks": "prízračné dosky",
  "block.minecraft.oak_sapling": "dubová sadenica",
  "block.minecraft.spruce_sapling": "smreková sadenica",
  "block.minecraft.birch_sapling": "brezová sadenica",
  "block.minecraft.jungle_sapling": "džungľová sadenica",
  "block.minecraft.acacia_sapling": "akáciová sadenica",
  "block.minecraft.dark_oak_sapling": "sadenica tmavého dubu",
  "block.minecraft.bedrock": "podložie",
  "block.minecraft.sand": "piesok",
  "block.minecraft.red_sand": "červený piesok",
  "block.minecraft.gravel": "štrk",
  "block.minecraft.gold_ore": "zlatá ruda",
  "block.minecraft.iron_ore": "železná ruda",
  "block.minecraft.coal_ore": "ložisko uhlia",
  "block.minecraft.nether_gold_ore": "netherová zlatá ruda",
  "block.minecraft.oak_log": "dubový kmeň",
  "block.minecraft.spruce_log": "smrekový kmeň",
  "block.minecraft.birch_log": "brezový kmeň",
  "block.minecraft.jungle_log": "džungľový kmeň",
  "block.minecraft.acacia_log": "akáciový kmeň",
  "block.minecraft.dark_oak_log": "kmeň tmavého dubu",
  "block.minecraft.crimson_stem": "karmínový hlúbik",
  "block.minecraft.warped_stem": "prízračný hlúbik",
  "block.minecraft.stripped_oak_log": "olúpaný dubový kmeň",
  "block.minecraft.stripped_spruce_log": "olúpaný smrekový kmeň",
  "block.minecraft.stripped_birch_log": "olúpaný brezový kmeň",
  "block.minecraft.stripped_jungle_log": "olúpaný džungľový kmeň",
  "block.minecraft.stripped_acacia_log": "olúpaný akáciový kmeň",
  "block.minecraft.stripped_dark_oak_log": "olúpaný kmeň tmavého dubu",
  "block.minecraft.stripped_crimson_stem": "olúpaný karmínový hlúbik",
  "block.minecraft.stripped_warped_stem": "olúpaný prízračný hlúbik",
  "block.minecraft.stripped_oak_wood": "olúpané dubové drevo",
  "block.minecraft.stripped_spruce_wood": "olúpané smrekové drevo",
  "block.minecraft.stripped_birch_wood": "olúpané brezové drevo",
  "block.minecraft.stripped_jungle_wood": "olúpané džungľové drevo",
  "block.minecraft.stripped_acacia_wood": "olúpané akáciové drevo",
  "block.minecraft.stripped_dark_oak_wood": "olúpané drevo z tmavého dubu",
  "block.minecraft.stripped_crimson_hyphae": "olúpaná karmínová stielka",
  "block.minecraft.stripped_warped_hyphae": "olúpaná prízračná stielka",
  "block.minecraft.oak_wood": "dubové drevo",
  "block.minecraft.spruce_wood": "smrekové drevo",
  "block.minecraft.birch_wood": "brezové drevo",
  "block.minecraft.jungle_wood": "džungľové drevo",
  "block.minecraft.acacia_wood": "akáciové drevo",
  "block.minecraft.dark_oak_wood": "drevo z tmavého dubu",
  "block.minecraft.crimson_hyphae": "karmínová stielka",
  "block.minecraft.warped_hyphae": "prízračná stielka",
  "block.minecraft.oak_leaves": "dubové listy",
  "block.minecraft.spruce_leaves": "smrekové ihličie",
  "block.minecraft.birch_leaves": "brezové listy",
  "block.minecraft.jungle_leaves": "džungľové listy",
  "block.minecraft.acacia_leaves": "akáciové listy",
  "block.minecraft.dark_oak_leaves": "listy tmavého dubu",
  "block.minecraft.sponge": "špongia",
  "block.minecraft.wet_sponge": "vlhká špongia",
  "block.minecraft.glass": "sklo",
  "block.minecraft.lapis_ore": "ložisko lazuritu",
  "block.minecraft.lapis_block": "kocka lazuritu",
  "block.minecraft.dispenser": "dávkovač",
  "block.minecraft.sandstone": "pieskovec",
  "block.minecraft.chiseled_sandstone": "otesaný pieskovec",
  "block.minecraft.cut_sandstone": "rezaný pieskovec",
  "block.minecraft.note_block": "hudobná kocka",
  "block.minecraft.powered_rail": "napájané koľajnice",
  "block.minecraft.detector_rail": "koľajnice so senzorom",
  "block.minecraft.sticky_piston": "lepkavý piest",
  "block.minecraft.cobweb": "pavučina",
  "block.minecraft.grass": "tráva",
  "block.minecraft.fern": "papraď",
  "block.minecraft.dead_bush": "suchý ker",
  "block.minecraft.seagrass": "morská tráva",
  "block.minecraft.sea_pickle": "morská uhorka",
  "block.minecraft.piston": "piest",
  "block.minecraft.white_wool": "biela vlna",
  "block.minecraft.orange_wool": "oranžová vlna",
  "block.minecraft.magenta_wool": "purpurová vlna",
  "block.minecraft.light_blue_wool": "svetlomodrá vlna",
  "block.minecraft.yellow_wool": "žltá vlna",
  "block.minecraft.lime_wool": "svetlozelená vlna",
  "block.minecraft.pink_wool": "ružová vlna",
  "block.minecraft.gray_wool": "sivá vlna",
  "block.minecraft.light_gray_wool": "svetlosivá vlna",
  "block.minecraft.cyan_wool": "tyrkysová vlna",
  "block.minecraft.purple_wool": "fialová vlna",
  "block.minecraft.blue_wool": "modrá vlna",
  "block.minecraft.brown_wool": "hnedá vlna",
  "block.minecraft.green_wool": "zelená vlna",
  "block.minecraft.red_wool": "červená vlna",
  "block.minecraft.black_wool": "čierna vlna",
  "block.minecraft.dandelion": "púpava",
  "block.minecraft.poppy": "vlčí mak",
  "block.minecraft.blue_orchid": "modrá orchidea",
  "block.minecraft.allium": "okrasný cesnak",
  "block.minecraft.azure_bluet": "houstónia",
  "block.minecraft.red_tulip": "červený tulipán",
  "block.minecraft.orange_tulip": "oranžový tulipán",
  "block.minecraft.white_tulip": "biely tulipán",
  "block.minecraft.pink_tulip": "ružový tulipán",
  "block.minecraft.oxeye_daisy": "margaréta",
  "block.minecraft.cornflower": "nevädza",
  "block.minecraft.lily_of_the_valley": "konvalinka",
  "block.minecraft.wither_rose": "witherova ruža",
  "block.minecraft.brown_mushroom": "hnedý hríb",
  "block.minecraft.red_mushroom": "muchotrávka",
  "block.minecraft.crimson_fungus": "karmínová huba",
  "block.minecraft.warped_fungus": "prízračná huba",
  "block.minecraft.crimson_roots": "karmínové korienky",
  "block.minecraft.warped_roots": "prízračné korienky",
  "block.minecraft.nether_sprouts": "netherové klíčky",
  "block.minecraft.weeping_vines": "karmínové liany",
  "block.minecraft.twisting_vines": "prízračné liany",
  "block.minecraft.sugar_cane": "cukrová trstina",
  "block.minecraft.kelp": "chaluha",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "kocka zlata",
  "block.minecraft.iron_block": "kocka železa",
  "block.minecraft.oak_slab": "dubový stupienok",
  "block.minecraft.spruce_slab": "smrekový stupienok",
  "block.minecraft.birch_slab": "brezový stupienok",
  "block.minecraft.jungle_slab": "džungľový stupienok",
  "block.minecraft.acacia_slab": "akáciový stupienok",
  "block.minecraft.dark_oak_slab": "stupienok z tmavého dubu",
  "block.minecraft.crimson_slab": "karmínový stupienok",
  "block.minecraft.warped_slab": "prízračný stupienok",
  "block.minecraft.stone_slab": "kamenný stupienok",
  "block.minecraft.smooth_stone_slab": "stupienok z hladkého kameňa",
  "block.minecraft.sandstone_slab": "pieskovcový stupienok",
  "block.minecraft.cut_sandstone_slab": "stupienok z rezaného pieskovca",
  "block.minecraft.petrified_oak_slab": "skamenelý dubový stupienok",
  "block.minecraft.cobblestone_slab": "stupienok z dlažobného kameňa",
  "block.minecraft.brick_slab": "tehlový stupienok",
  "block.minecraft.stone_brick_slab": "stupienok z kamenných tehál",
  "block.minecraft.nether_brick_slab": "stupienok z nether tehál",
  "block.minecraft.quartz_slab": "kremenný stupienok",
  "block.minecraft.red_sandstone_slab": "stupienok z červeného pieskovca",
  "block.minecraft.cut_red_sandstone_slab": "stupienok z rezaného červeného pieskovca",
  "block.minecraft.purpur_slab": "purpurový stupienok",
  "block.minecraft.prismarine_slab": "prizmarínový stupienok",
  "block.minecraft.prismarine_brick_slab": "stupienok z prizmarínových tehál",
  "block.minecraft.dark_prismarine_slab": "stupienok z tmavého prizmarínu",
  "block.minecraft.smooth_quartz": "kocka hladkého kremeňa",
  "block.minecraft.smooth_red_sandstone": "hladký červený pieskovec",
  "block.minecraft.smooth_sandstone": "hladký pieskovec",
  "block.minecraft.smooth_stone": "hladký kameň",
  "block.minecraft.bricks": "tehly",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "knižnica",
  "block.minecraft.mossy_cobblestone": "zarastený dlažobný kameň",
  "block.minecraft.obsidian": "obsidián",
  "block.minecraft.torch": "fakľa",
  "block.minecraft.end_rod": "endová tyč",
  "block.minecraft.chorus_plant": "chorusová rastlina",
  "block.minecraft.chorus_flower": "chorusový kvet",
  "block.minecraft.purpur_block": "purpurová kocka",
  "block.minecraft.purpur_pillar": "purpurový stĺp",
  "block.minecraft.purpur_stairs": "purpurové schody",
  "block.minecraft.spawner": "liaheň",
  "block.minecraft.oak_stairs": "dubové schody",
  "block.minecraft.chest": "truhlica",
  "block.minecraft.diamond_ore": "ložisko diamantu",
  "block.minecraft.diamond_block": "diamantová kocka",
  "block.minecraft.crafting_table": "pracovný stôl",
  "block.minecraft.farmland": "zoraná pôda",
  "block.minecraft.furnace": "pec",
  "block.minecraft.ladder": "rebrík",
  "block.minecraft.rail": "koľajnice",
  "block.minecraft.cobblestone_stairs": "schody z dlažobného kameňa",
  "block.minecraft.lever": "páka",
  "block.minecraft.stone_pressure_plate": "kamenná nášľapná doska",
  "block.minecraft.oak_pressure_plate": "dubová nášľapná doska",
  "block.minecraft.spruce_pressure_plate": "smreková nášľapná doska",
  "block.minecraft.birch_pressure_plate": "brezová nášľapná doska",
  "block.minecraft.jungle_pressure_plate": "džungľová nášľapná doska",
  "block.minecraft.acacia_pressure_plate": "akáciová nášľapná doska",
  "block.minecraft.dark_oak_pressure_plate": "nášľapná doska z tmavého dubu",
  "block.minecraft.crimson_pressure_plate": "karmínová nášľapná doska",
  "block.minecraft.warped_pressure_plate": "prízračná nášľapná doska",
  "block.minecraft.polished_blackstone_pressure_plate": "nášľapná doska z lešteného čierneho kameňa",
  "block.minecraft.redstone_ore": "ložisko redstonu",
  "block.minecraft.redstone_torch": "redstonová fakľa",
  "block.minecraft.snow": "sneh",
  "block.minecraft.ice": "ľad",
  "block.minecraft.snow_block": "kocka snehu",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "íl",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "dubový plot",
  "block.minecraft.spruce_fence": "smrekový plot",
  "block.minecraft.birch_fence": "brezový plot",
  "block.minecraft.jungle_fence": "džungľový plot",
  "block.minecraft.acacia_fence": "akáciový plot",
  "block.minecraft.dark_oak_fence": "plot z tmavého dubu",
  "block.minecraft.crimson_fence": "karmínový plot",
  "block.minecraft.warped_fence": "prízračný plot",
  "block.minecraft.pumpkin": "tekvica",
  "block.minecraft.carved_pumpkin": "vyrezaná tekvica",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "piesok duší",
  "block.minecraft.soul_soil": "pôda duší",
  "block.minecraft.basalt": "čadič",
  "block.minecraft.polished_basalt": "leštený čadič",
  "block.minecraft.soul_torch": "fakľa s ohňom duší",
  "block.minecraft.glowstone": "svietivec",
  "block.minecraft.jack_o_lantern": "tekvicový lampáš",
  "block.minecraft.oak_trapdoor": "dubový poklop",
  "block.minecraft.spruce_trapdoor": "smrekový poklop",
  "block.minecraft.birch_trapdoor": "brezový poklop",
  "block.minecraft.jungle_trapdoor": "džungľový poklop",
  "block.minecraft.acacia_trapdoor": "akáciový poklop",
  "block.minecraft.dark_oak_trapdoor": "poklop z tmavého dubu",
  "block.minecraft.crimson_trapdoor": "karmínový poklop",
  "block.minecraft.warped_trapdoor": "prízračný poklop",
  "block.minecraft.infested_stone": "zamorený kameň",
  "block.minecraft.infested_cobblestone": "zamorený dlažobný kameň",
  "block.minecraft.infested_stone_bricks": "zamorené kamenné tehly",
  "block.minecraft.infested_mossy_stone_bricks": "zamorené zarastené kamenné tehly",
  "block.minecraft.infested_cracked_stone_bricks": "zamorené popraskané kamenné tehly",
  "block.minecraft.infested_chiseled_stone_bricks": "zamorené otesané kamenné tehly",
  "block.minecraft.stone_bricks": "kamenné tehly",
  "block.minecraft.mossy_stone_bricks": "zarastené kamenné tehly",
  "block.minecraft.cracked_stone_bricks": "popraskané kamenné tehly",
  "block.minecraft.chiseled_stone_bricks": "otesané kamenné tehly",
  "block.minecraft.brown_mushroom_block": "hríbová kocka",
  "block.minecraft.red_mushroom_block": "muchotrávková kocka",
  "block.minecraft.mushroom_stem": "hlúbik",
  "block.minecraft.iron_bars": "železné mreže",
  "block.minecraft.chain": "reťaz",
  "block.minecraft.glass_pane": "sklenený panel",
  "block.minecraft.melon": "melón",
  "block.minecraft.vine": "liany",
  "block.minecraft.oak_fence_gate": "dubová bránka",
  "block.minecraft.spruce_fence_gate": "smreková bránka",
  "block.minecraft.birch_fence_gate": "brezová bránka",
  "block.minecraft.jungle_fence_gate": "džungľová bránka",
  "block.minecraft.acacia_fence_gate": "akáciová bránka",
  "block.minecraft.dark_oak_fence_gate": "bránka z tmavého dubu",
  "block.minecraft.crimson_fence_gate": "karmínová bránka",
  "block.minecraft.warped_fence_gate": "prízračná bránka",
  "block.minecraft.brick_stairs": "tehlové schody",
  "block.minecraft.stone_brick_stairs": "schody z kamenných tehál",
  "block.minecraft.mycelium": "podhubie",
  "block.minecraft.lily_pad": "lekno",
  "block.minecraft.nether_bricks": "nether tehly",
  "block.minecraft.cracked_nether_bricks": "popraskané nether tehly",
  "block.minecraft.chiseled_nether_bricks": "otesané nether tehly",
  "block.minecraft.nether_brick_fence": "plot z nether tehál",
  "block.minecraft.nether_brick_stairs": "schody z nether tehál",
  "block.minecraft.enchanting_table": "stôl očarovania",
  "block.minecraft.end_portal_frame": "rám portálu do endu",
  "block.minecraft.end_stone": "enderit",
  "block.minecraft.end_stone_bricks": "enderitové tehly",
  "block.minecraft.dragon_egg": "dračie vajce",
  "block.minecraft.redstone_lamp": "redstonová lampa",
  "block.minecraft.sandstone_stairs": "pieskovcové schody",
  "block.minecraft.emerald_ore": "ložisko smaragdu",
  "block.minecraft.ender_chest": "ender truhlica",
  "block.minecraft.tripwire_hook": "úchyt nástražnej šnúry",
  "block.minecraft.emerald_block": "smaragdová kocka",
  "block.minecraft.spruce_stairs": "smrekové schody",
  "block.minecraft.birch_stairs": "brezové schody",
  "block.minecraft.jungle_stairs": "džungľové schody",
  "block.minecraft.crimson_stairs": "karmínové schody",
  "block.minecraft.warped_stairs": "prízračné schody",
  "block.minecraft.command_block": "príkazová kocka",
  "block.minecraft.beacon": "maják",
  "block.minecraft.cobblestone_wall": "kamenný múr",
  "block.minecraft.mossy_cobblestone_wall": "zarastený kamený múr",
  "block.minecraft.brick_wall": "tehlový múr",
  "block.minecraft.prismarine_wall": "prizmarínový múr",
  "block.minecraft.red_sandstone_wall": "múr z červeného pieskovca",
  "block.minecraft.mossy_stone_brick_wall": "zarastený múr z kamenných tehál",
  "block.minecraft.granite_wall": "žulový múr",
  "block.minecraft.stone_brick_wall": "múr z kamenných tehál",
  "block.minecraft.nether_brick_wall": "múr z nether tehál",
  "block.minecraft.andesite_wall": "andezitový múr",
  "block.minecraft.red_nether_brick_wall": "múr z červených nether tehál",
  "block.minecraft.sandstone_wall": "pieskovcový múr",
  "block.minecraft.end_stone_brick_wall": "múr z enderitových tehál",
  "block.minecraft.diorite_wall": "dioritový múr",
  "block.minecraft.blackstone_wall": "múr z čierneho kameňa",
  "block.minecraft.polished_blackstone_wall": "múr z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_brick_wall": "múr z tehál z lešteného čierneho kameňa",
  "block.minecraft.stone_button": "kamenné tlačidlo",
  "block.minecraft.oak_button": "dubové tlačidlo",
  "block.minecraft.spruce_button": "smrekové tlačidlo",
  "block.minecraft.birch_button": "brezové tlačidlo",
  "block.minecraft.jungle_button": "džungľové tlačidlo",
  "block.minecraft.acacia_button": "akáciové tlačidlo",
  "block.minecraft.dark_oak_button": "tlačidlo z tmavého dubu",
  "block.minecraft.crimson_button": "karmínové tlačidlo",
  "block.minecraft.warped_button": "prízračné tlačidlo",
  "block.minecraft.polished_blackstone_button": "tlačidlo z lešteného čierneho kameňa",
  "block.minecraft.anvil": "nákova",
  "block.minecraft.chipped_anvil": "poškriabaná nákova",
  "block.minecraft.damaged_anvil": "poškodená nákova",
  "block.minecraft.trapped_chest": "truhlica s pascou",
  "block.minecraft.light_weighted_pressure_plate": "vážená nášľapná doska (jemná)",
  "block.minecraft.heavy_weighted_pressure_plate": "vážená nášľapná doska (silná)",
  "block.minecraft.daylight_detector": "detektor denného svetla",
  "block.minecraft.redstone_block": "kocka redstonu",
  "block.minecraft.nether_quartz_ore": "ložisko nether kremeňa",
  "block.minecraft.hopper": "násypník",
  "block.minecraft.chiseled_quartz_block": "otesaná kocka kremeňa",
  "block.minecraft.quartz_block": "kocka kremeňa",
  "block.minecraft.quartz_bricks": "kremenné tehly",
  "block.minecraft.quartz_pillar": "kremenný stĺp",
  "block.minecraft.quartz_stairs": "kremenné schody",
  "block.minecraft.activator_rail": "aktivačné koľajnice",
  "block.minecraft.dropper": "vyhadzovač",
  "block.minecraft.white_terracotta": "biela terakota",
  "block.minecraft.orange_terracotta": "oranžová terakota",
  "block.minecraft.magenta_terracotta": "purpurová terakota",
  "block.minecraft.light_blue_terracotta": "svetlomodrá terakota",
  "block.minecraft.yellow_terracotta": "žltá terakota",
  "block.minecraft.lime_terracotta": "svetlozelená terakota",
  "block.minecraft.pink_terracotta": "ružová terakota",
  "block.minecraft.gray_terracotta": "sivá terakota",
  "block.minecraft.light_gray_terracotta": "svetlosivá terakota",
  "block.minecraft.cyan_terracotta": "tyrkysová terakota",
  "block.minecraft.purple_terracotta": "fialová terakota",
  "block.minecraft.blue_terracotta": "modrá terakota",
  "block.minecraft.brown_terracotta": "hnedá terakota",
  "block.minecraft.green_terracotta": "zelená terakota",
  "block.minecraft.red_terracotta": "červená terakota",
  "block.minecraft.black_terracotta": "čierna terakota",
  "block.minecraft.barrier": "bariéra",
  "block.minecraft.iron_trapdoor": "železný poklop",
  "block.minecraft.hay_block": "zväzok sena",
  "block.minecraft.white_carpet": "biely koberec",
  "block.minecraft.orange_carpet": "oranžový koberec",
  "block.minecraft.magenta_carpet": "purpurový koberec",
  "block.minecraft.light_blue_carpet": "svetlomodrý koberec",
  "block.minecraft.yellow_carpet": "žltý koberec",
  "block.minecraft.lime_carpet": "svetlozelený koberec",
  "block.minecraft.pink_carpet": "ružový koberec",
  "block.minecraft.gray_carpet": "sivý koberec",
  "block.minecraft.light_gray_carpet": "svetlosivý koberec",
  "block.minecraft.cyan_carpet": "tyrkysový koberec",
  "block.minecraft.purple_carpet": "fialový koberec",
  "block.minecraft.blue_carpet": "modrý koberec",
  "block.minecraft.brown_carpet": "hnedý koberec",
  "block.minecraft.green_carpet": "zelený koberec",
  "block.minecraft.red_carpet": "červený koberec",
  "block.minecraft.black_carpet": "čierny koberec",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "kocka uhlia",
  "block.minecraft.packed_ice": "tvrdý ľad",
  "block.minecraft.acacia_stairs": "akáciové schody",
  "block.minecraft.dark_oak_stairs": "schody z tmavého dubu",
  "block.minecraft.slime_block": "kocka slizu",
  "block.minecraft.grass_path": "trávnatá cesta",
  "block.minecraft.sunflower": "slnečnica",
  "block.minecraft.lilac": "orgován",
  "block.minecraft.rose_bush": "ružový krík",
  "block.minecraft.peony": "pivónia",
  "block.minecraft.tall_grass": "vysoká tráva",
  "block.minecraft.large_fern": "veľká papraď",
  "block.minecraft.white_stained_glass": "biele sklo",
  "block.minecraft.orange_stained_glass": "oranžové sklo",
  "block.minecraft.magenta_stained_glass": "purpurové sklo",
  "block.minecraft.light_blue_stained_glass": "svetlomodré sklo",
  "block.minecraft.yellow_stained_glass": "žlté sklo",
  "block.minecraft.lime_stained_glass": "svetlozelené sklo",
  "block.minecraft.pink_stained_glass": "ružové sklo",
  "block.minecraft.gray_stained_glass": "sivé sklo",
  "block.minecraft.light_gray_stained_glass": "svetlosivé sklo",
  "block.minecraft.cyan_stained_glass": "tyrkysové sklo",
  "block.minecraft.purple_stained_glass": "fialové sklo",
  "block.minecraft.blue_stained_glass": "modré sklo",
  "block.minecraft.brown_stained_glass": "hnedé sklo",
  "block.minecraft.green_stained_glass": "zelené sklo",
  "block.minecraft.red_stained_glass": "červené sklo",
  "block.minecraft.black_stained_glass": "čierne sklo",
  "block.minecraft.white_stained_glass_pane": "biely sklenený panel",
  "block.minecraft.orange_stained_glass_pane": "oranžový sklenený panel",
  "block.minecraft.magenta_stained_glass_pane": "purpurový sklenený panel",
  "block.minecraft.light_blue_stained_glass_pane": "svetlomodrý sklenený panel",
  "block.minecraft.yellow_stained_glass_pane": "žltý sklenený panel",
  "block.minecraft.lime_stained_glass_pane": "svetlozelený sklenený panel",
  "block.minecraft.pink_stained_glass_pane": "ružový sklenený panel",
  "block.minecraft.gray_stained_glass_pane": "sivý sklenený panel",
  "block.minecraft.light_gray_stained_glass_pane": "svetlosivý sklenený panel",
  "block.minecraft.cyan_stained_glass_pane": "tyrkysový sklenený panel",
  "block.minecraft.purple_stained_glass_pane": "fialový sklenený panel",
  "block.minecraft.blue_stained_glass_pane": "modrý sklenený panel",
  "block.minecraft.brown_stained_glass_pane": "hnedý sklenený panel",
  "block.minecraft.green_stained_glass_pane": "zelený sklenený panel",
  "block.minecraft.red_stained_glass_pane": "červený sklenený panel",
  "block.minecraft.black_stained_glass_pane": "čierny sklenený panel",
  "block.minecraft.prismarine": "prizmarín",
  "block.minecraft.prismarine_bricks": "prizmarínové tehly",
  "block.minecraft.dark_prismarine": "tmavý prizmarín",
  "block.minecraft.prismarine_stairs": "schody z prizmarínu",
  "block.minecraft.prismarine_brick_stairs": "schody z prizmarínových tehál",
  "block.minecraft.dark_prismarine_stairs": "schody z tmavého prizmarínu",
  "block.minecraft.sea_lantern": "morský lampáš",
  "block.minecraft.red_sandstone": "červený pieskovec",
  "block.minecraft.chiseled_red_sandstone": "otesaný červený pieskovec",
  "block.minecraft.cut_red_sandstone": "rezaný červený pieskovec",
  "block.minecraft.red_sandstone_stairs": "schody z červeného pieskovca",
  "block.minecraft.repeating_command_block": "opakujúca príkazová kocka",
  "block.minecraft.chain_command_block": "reťazová príkazová kocka",
  "block.minecraft.magma_block": "kocka magmy",
  "block.minecraft.nether_wart_block": "kocka nether bradavíc",
  "block.minecraft.warped_wart_block": "kocka prízračných bradavíc",
  "block.minecraft.red_nether_bricks": "červené nether tehly",
  "block.minecraft.bone_block": "kocka kostí",
  "block.minecraft.structure_void": "štruktúrové prázdno",
  "block.minecraft.observer": "pozorovacia kocka",
  "block.minecraft.shulker_box": "shulker schránka",
  "block.minecraft.white_shulker_box": "biela shulker schránka",
  "block.minecraft.orange_shulker_box": "oranžová shulker schránka",
  "block.minecraft.magenta_shulker_box": "purpurová shulker schránka",
  "block.minecraft.light_blue_shulker_box": "svetlomodrá shulker schránka",
  "block.minecraft.yellow_shulker_box": "žltá shulker schránka",
  "block.minecraft.lime_shulker_box": "svetlozelená shulker schránka",
  "block.minecraft.pink_shulker_box": "ružová shulker schránka",
  "block.minecraft.gray_shulker_box": "sivá shulker schránka",
  "block.minecraft.light_gray_shulker_box": "svetlosivá shulker schránka",
  "block.minecraft.cyan_shulker_box": "tyrkysová shulker schránka",
  "block.minecraft.purple_shulker_box": "fialová shulker schránka",
  "block.minecraft.blue_shulker_box": "modrá shulker schránka",
  "block.minecraft.brown_shulker_box": "hnedá shulker schránka",
  "block.minecraft.green_shulker_box": "zelená shulker schránka",
  "block.minecraft.red_shulker_box": "červená shulker schránka",
  "block.minecraft.black_shulker_box": "čierna shulker schránka",
  "block.minecraft.white_glazed_terracotta": "biela glazovaná terakota",
  "block.minecraft.orange_glazed_terracotta": "oranžová glazovaná terakota",
  "block.minecraft.magenta_glazed_terracotta": "purpurová glazovaná terakota",
  "block.minecraft.light_blue_glazed_terracotta": "svetlomodrá glazovaná terakota",
  "block.minecraft.yellow_glazed_terracotta": "žltá glazovaná terakota",
  "block.minecraft.lime_glazed_terracotta": "svetlozelená glazovaná terakota",
  "block.minecraft.pink_glazed_terracotta": "ružová glazovaná terakota",
  "block.minecraft.gray_glazed_terracotta": "sivá glazovaná terakota",
  "block.minecraft.light_gray_glazed_terracotta": "svetlosivá glazovaná terakota",
  "block.minecraft.cyan_glazed_terracotta": "tyrkysová glazovaná terakota",
  "block.minecraft.purple_glazed_terracotta": "fialová glazovaná terakota",
  "block.minecraft.blue_glazed_terracotta": "modrá glazovaná terakota",
  "block.minecraft.brown_glazed_terracotta": "hnedá glazovaná terakota",
  "block.minecraft.green_glazed_terracotta": "zelená glazovaná terakota",
  "block.minecraft.red_glazed_terracotta": "červená glazovaná terakota",
  "block.minecraft.black_glazed_terracotta": "čierna glazovaná terakota",
  "block.minecraft.white_concrete": "biely betón",
  "block.minecraft.orange_concrete": "oranžový betón",
  "block.minecraft.magenta_concrete": "purpurový betón",
  "block.minecraft.light_blue_concrete": "svetlomodrý betón",
  "block.minecraft.yellow_concrete": "žltý betón",
  "block.minecraft.lime_concrete": "svetlozelený betón",
  "block.minecraft.pink_concrete": "ružový betón",
  "block.minecraft.gray_concrete": "sivý betón",
  "block.minecraft.light_gray_concrete": "svetlosivý betón",
  "block.minecraft.cyan_concrete": "tyrkysový betón",
  "block.minecraft.purple_concrete": "fialový betón",
  "block.minecraft.blue_concrete": "modrý betón",
  "block.minecraft.brown_concrete": "hnedý betón",
  "block.minecraft.green_concrete": "zelený betón",
  "block.minecraft.red_concrete": "červený betón",
  "block.minecraft.black_concrete": "čierny betón",
  "block.minecraft.white_concrete_powder": "biely cement",
  "block.minecraft.orange_concrete_powder": "oranžový cement",
  "block.minecraft.magenta_concrete_powder": "purpurový cement",
  "block.minecraft.light_blue_concrete_powder": "svetlomodrý cement",
  "block.minecraft.yellow_concrete_powder": "žltý cement",
  "block.minecraft.lime_concrete_powder": "svetlozelený cement",
  "block.minecraft.pink_concrete_powder": "ružový cement",
  "block.minecraft.gray_concrete_powder": "sivý cement",
  "block.minecraft.light_gray_concrete_powder": "svetlosivý cement",
  "block.minecraft.cyan_concrete_powder": "tyrkysový cement",
  "block.minecraft.purple_concrete_powder": "fialový cement",
  "block.minecraft.blue_concrete_powder": "modrý cement",
  "block.minecraft.brown_concrete_powder": "hnedý cement",
  "block.minecraft.green_concrete_powder": "zelený cement",
  "block.minecraft.red_concrete_powder": "červený cement",
  "block.minecraft.black_concrete_powder": "čierny cement",
  "block.minecraft.turtle_egg": "korytnačie vajce",
  "block.minecraft.dead_tube_coral_block": "kocka uhynutého rúrkovitého koralu",
  "block.minecraft.dead_brain_coral_block": "kocka uhynutého mozgovitého koralu",
  "block.minecraft.dead_bubble_coral_block": "kocka uhynutého bobuľovitého koralu",
  "block.minecraft.dead_fire_coral_block": "kocka uhynutého plameňovitého koralu",
  "block.minecraft.dead_horn_coral_block": "kocka uhynutého parohovitého koralu",
  "block.minecraft.tube_coral_block": "kocka rúrkovitého koralu",
  "block.minecraft.brain_coral_block": "kocka mozgovitého koralu",
  "block.minecraft.bubble_coral_block": "kocka bobuľovitého koralu",
  "block.minecraft.fire_coral_block": "kocka plameňovitého koralu",
  "block.minecraft.horn_coral_block": "kocka parohovitého koralu",
  "block.minecraft.tube_coral": "rúrkovitý koral",
  "block.minecraft.brain_coral": "mozgovitý koral",
  "block.minecraft.bubble_coral": "bobuľovitý koral",
  "block.minecraft.fire_coral": "plameňovitý koral",
  "block.minecraft.horn_coral": "parohovitý koral",
  "block.minecraft.dead_brain_coral": "uhynutý mozgovitý koral",
  "block.minecraft.dead_bubble_coral": "uhynutý bobuľovitý koral",
  "block.minecraft.dead_fire_coral": "uhynutý plameňovitý koral",
  "block.minecraft.dead_horn_coral": "uhynutý parohovitý koral",
  "block.minecraft.dead_tube_coral": "uhynutý rúrkovitý koral",
  "block.minecraft.tube_coral_fan": "vejár rúrkovitého koralu",
  "block.minecraft.brain_coral_fan": "vejár mozgovitého koralu",
  "block.minecraft.bubble_coral_fan": "vejár bobuľovitého koralu",
  "block.minecraft.fire_coral_fan": "vejár plameňovitého koralu",
  "block.minecraft.horn_coral_fan": "vejár parohovitého koralu",
  "block.minecraft.dead_tube_coral_fan": "vejár uhynutého rúrkovitého koralu",
  "block.minecraft.dead_brain_coral_fan": "vejár uhynutého mozgovitého koralu",
  "block.minecraft.dead_bubble_coral_fan": "vejár uhynutého bobuľovitého koralu",
  "block.minecraft.dead_fire_coral_fan": "vejár uhynutého plameňovitého koralu",
  "block.minecraft.dead_horn_coral_fan": "vejár uhynutého parohovitého koralu",
  "block.minecraft.blue_ice": "modrý ľad",
  "block.minecraft.conduit": "silovod",
  "block.minecraft.polished_granite_stairs": "schody z leštenej žuly",
  "block.minecraft.smooth_red_sandstone_stairs": "schody z hladkého červeného pieskovca",
  "block.minecraft.mossy_stone_brick_stairs": "zarastené schody z kamenných tehál",
  "block.minecraft.polished_diorite_stairs": "schody z lešteného dioritu",
  "block.minecraft.mossy_cobblestone_stairs": "zarastené schody z dlažobného kameňa",
  "block.minecraft.end_stone_brick_stairs": "schody z enderitových tehál",
  "block.minecraft.stone_stairs": "kamenné schody",
  "block.minecraft.smooth_sandstone_stairs": "schody z hladkého pieskovca",
  "block.minecraft.smooth_quartz_stairs": "schody z hladkého kremeňa",
  "block.minecraft.granite_stairs": "žulové schody",
  "block.minecraft.andesite_stairs": "andezitové schody",
  "block.minecraft.red_nether_brick_stairs": "schody z červených nether tehál",
  "block.minecraft.polished_andesite_stairs": "schody z lešteného andezitu",
  "block.minecraft.diorite_stairs": "dioritové schody",
  "block.minecraft.polished_granite_slab": "stupienok z leštenej žuly",
  "block.minecraft.smooth_red_sandstone_slab": "stupienok z hladkého červeného pieskovca",
  "block.minecraft.mossy_stone_brick_slab": "zarastený stupienok z kamenných tehál",
  "block.minecraft.polished_diorite_slab": "stupienok z lešteného dioritu",
  "block.minecraft.mossy_cobblestone_slab": "zarastený stupienok z dlažobného kameňa",
  "block.minecraft.end_stone_brick_slab": "stupienok z enderitových tehál",
  "block.minecraft.smooth_sandstone_slab": "stupienok z hladkého pieskovca",
  "block.minecraft.smooth_quartz_slab": "stupienok z hladkého kremeňa",
  "block.minecraft.granite_slab": "žulový stupienok",
  "block.minecraft.andesite_slab": "andezitový stupienok",
  "block.minecraft.red_nether_brick_slab": "stupienok z červených nether tehál",
  "block.minecraft.polished_andesite_slab": "stupienok z lešteného andezitu",
  "block.minecraft.diorite_slab": "dioritový stupienok",
  "block.minecraft.scaffolding": "lešenie",
  "block.minecraft.iron_door": "železné dvere",
  "block.minecraft.oak_door": "dubové dvere",
  "block.minecraft.spruce_door": "smrekové dvere",
  "block.minecraft.birch_door": "brezové dvere",
  "block.minecraft.jungle_door": "džungľové dvere",
  "block.minecraft.acacia_door": "akáciové dvere",
  "block.minecraft.dark_oak_door": "dvere z tmavého dubu",
  "block.minecraft.crimson_door": "karmínové dvere",
  "block.minecraft.warped_door": "prízračné dvere",
  "block.minecraft.repeater": "redstonový opakovač",
  "block.minecraft.comparator": "redstonový porovnávač",
  "block.minecraft.structure_block": "štruktúrová kocka",
  "block.minecraft.jigsaw": "skladačková kocka",
  "item.minecraft.turtle_helmet": "korytnačí pancier□□na hlave:□+2 brnenie",
  "item.minecraft.scute": "korytnačia doštička",
  "item.minecraft.iron_shovel": "železná lopata□□v hlavnej ruke:□+3.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.iron_pickaxe": "železný krompáč□□v hlavnej ruke:□+3 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.iron_axe": "železná sekera□□v hlavnej ruke:□+8 sila útoku□–3.1 rýchlosť útoku",
  "item.minecraft.flint_and_steel": "kresadlo",
  "item.minecraft.apple": "jablko",
  "item.minecraft.bow": "luk",
  "item.minecraft.arrow": "šíp",
  "item.minecraft.coal": "uhlie",
  "item.minecraft.charcoal": "drevené uhlie",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "železná tehlička",
  "item.minecraft.gold_ingot": "zlatá tehlička",
  "item.minecraft.netherite_ingot": "netheritová tehlička",
  "item.minecraft.netherite_scrap": "netheritový šrot",
  "item.minecraft.iron_sword": "železný meč□□v hlavnej ruke:□+5 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.wooden_sword": "drevený meč□□v hlavnej ruke:□+3 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.wooden_shovel": "drevená lopata□□v hlavnej ruke:□+1.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.wooden_pickaxe": "drevený krompáč□□v hlavnej ruke:□+1 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.wooden_axe": "drevená sekera□□v hlavnej ruke:□+6 sila útoku□–3.2 rýchlosť útoku",
  "item.minecraft.stone_sword": "kamenný meč□□v hlavnej ruke:□+4 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.stone_shovel": "kamenná lopata□□v hlavnej ruke:□+2.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.stone_pickaxe": "kamenný krompáč□□v hlavnej ruke:□+2 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.stone_axe": "kamenná sekera□□v hlavnej ruke:□+8 sila útoku□–3.2 rýchlosť útoku",
  "item.minecraft.diamond_sword": "diamantový meč□□v hlavnej ruke:□+6 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.diamond_shovel": "diamantová lopata□□v hlavnej ruke:□+4.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.diamond_pickaxe": "diamantový krompáč□□v hlavnej ruke:□+4 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.diamond_axe": "diamantová sekera□□v hlavnej ruke:□+8 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.stick": "palica",
  "item.minecraft.bowl": "miska",
  "item.minecraft.mushroom_stew": "hubová polievka",
  "item.minecraft.golden_sword": "zlatý meč□□v hlavnej ruke:□+3 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.golden_shovel": "zlatá lopata□□v hlavnej ruke:□+1.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.golden_pickaxe": "zlatý krompáč□□v hlavnej ruke:□+1 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.golden_axe": "zlatá sekera□□v hlavnej ruke:□+6 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.netherite_sword": "netheritový meč□□v hlavnej ruke:□+7 sila útoku□–2.4 rýchlosť útoku",
  "item.minecraft.netherite_shovel": "netheritová lopata□□v hlavnej ruke:□+5.5 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.netherite_pickaxe": "netheritový krompáč□□v hlavnej ruke:□+5 sila útoku□–2.8 rýchlosť útoku",
  "item.minecraft.netherite_axe": "netheritová sekera□□v hlavnej ruke:□+9 sila útoku□–3 rýchlosť útoku",
  "item.minecraft.string": "vlákno",
  "item.minecraft.feather": "pierko",
  "item.minecraft.gunpowder": "pušný prach",
  "item.minecraft.wooden_hoe": "drevená motyka□□v hlavnej ruke:□–3 rýchlosť útoku",
  "item.minecraft.stone_hoe": "kamenná motyka□□v hlavnej ruke:□–2 rýchlosť útoku",
  "item.minecraft.iron_hoe": "železná motyka□□v hlavnej ruke:□–1 rýchlosť útoku",
  "item.minecraft.diamond_hoe": "diamantová motyka□□v hlavnej ruke:",
  "item.minecraft.golden_hoe": "zlatá motyka□□v hlavnej ruke:□–3 rýchlosť útoku",
  "item.minecraft.netherite_hoe": "netheritová motyka□□v hlavnej ruke:",
  "item.minecraft.wheat_seeds": "pšeničné semienka",
  "item.minecraft.wheat": "pšenica",
  "item.minecraft.bread": "chlieb",
  "item.minecraft.leather_helmet": "kožená čiapka□□na hlave:□+1 brnenie",
  "item.minecraft.leather_chestplate": "kožená tunika□□na tele:□+3 brnenie",
  "item.minecraft.leather_leggings": "kožené nohavice□□na nohách:□+2 brnenie",
  "item.minecraft.leather_boots": "kožené topánky□□na chodidlách:□+1 brnenie",
  "item.minecraft.chainmail_helmet": "krúžková prilba□□na hlave:□+2 brnenie",
  "item.minecraft.chainmail_chestplate": "krúžkové brnenie□□na tele:□+5 brnenie",
  "item.minecraft.chainmail_leggings": "krúžkové nohavice□□na nohách:□+4 brnenie",
  "item.minecraft.chainmail_boots": "krúžkové topánky□□na chodidlách:□+1 brnenie",
  "item.minecraft.iron_helmet": "železná prilba□□na hlave:□+2 brnenie",
  "item.minecraft.iron_chestplate": "železné brnenie□□na tele:□+6 brnenie",
  "item.minecraft.iron_leggings": "železné nohavice□□na nohách:□+5 brnenie",
  "item.minecraft.iron_boots": "železné topánky□□na chodidlách:□+2 brnenie",
  "item.minecraft.diamond_helmet": "diamantová prilba□□na hlave:□+3 brnenie□+2 odolnosť brnenia",
  "item.minecraft.diamond_chestplate": "diamantové brnenie□□na tele:□+8 brnenie□+2 odolnosť brnenia",
  "item.minecraft.diamond_leggings": "diamantové nohavice□□na nohách:□+6 brnenie□+2 odolnosť brnenia",
  "item.minecraft.diamond_boots": "diamantové topánky□□na chodidlách:□+3 brnenie□+2 odolnosť brnenia",
  "item.minecraft.golden_helmet": "zlatá prilba□□na hlave:□+2 brnenie",
  "item.minecraft.golden_chestplate": "zlaté brnenie□□na tele:□+5 brnenie",
  "item.minecraft.golden_leggings": "zlaté nohavice□□na nohách:□+3 brnenie",
  "item.minecraft.golden_boots": "zlaté topánky□□na chodidlách:□+1 brnenie",
  "item.minecraft.netherite_helmet": "netheritová prilba□□na hlave:□+3 brnenie□+3 odolnosť brnenia□+1 odolnosť proti odrazeniu",
  "item.minecraft.netherite_chestplate": "netheritové brnenie□□na tele:□+8 brnenie□+3 odolnosť brnenia□+1 odolnosť proti odrazeniu",
  "item.minecraft.netherite_leggings": "netheritové nohavice□□na nohách:□+6 brnenie□+3 odolnosť brnenia□+1 odolnosť proti odrazeniu",
  "item.minecraft.netherite_boots": "netheritové topánky□□na chodidlách:□+3 brnenie□+3 odolnosť brnenia□+1 odolnosť proti odrazeniu",
  "item.minecraft.flint": "pazúrik",
  "item.minecraft.porkchop": "surové bravčové",
  "item.minecraft.cooked_porkchop": "pečené bravčové",
  "item.minecraft.painting": "obraz",
  "item.minecraft.golden_apple": "zlaté jablko",
  "item.minecraft.enchanted_golden_apple": "očarované zlaté jablko",
  "block.minecraft.oak_sign": "dubová ceduľa",
  "block.minecraft.spruce_sign": "smreková ceduľa",
  "block.minecraft.birch_sign": "brezová ceduľa",
  "block.minecraft.jungle_sign": "džungľová ceduľa",
  "block.minecraft.acacia_sign": "akáciová ceduľa",
  "block.minecraft.dark_oak_sign": "ceduľa z tmavého dubu",
  "block.minecraft.crimson_sign": "karmínová ceduľa",
  "block.minecraft.warped_sign": "prízračná ceduľa",
  "item.minecraft.bucket": "vedro",
  "item.minecraft.water_bucket": "vedro vody",
  "item.minecraft.lava_bucket": "vedro lávy",
  "item.minecraft.minecart": "vozík",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "redstonový prach",
  "item.minecraft.snowball": "snehová guľa",
  "item.minecraft.oak_boat": "dubový čln",
  "item.minecraft.leather": "koža",
  "item.minecraft.milk_bucket": "vedro mlieka",
  "item.minecraft.pufferfish_bucket": "vedro so štvorzubcom",
  "item.minecraft.salmon_bucket": "vedro s lososom",
  "item.minecraft.cod_bucket": "vedro s treskou",
  "item.minecraft.tropical_fish_bucket": "vedro s tropickou rybou",
  "item.minecraft.brick": "tehla",
  "item.minecraft.clay_ball": "hrudka ílu",
  "block.minecraft.dried_kelp_block": "kocka sušených chalúh",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "kniha",
  "item.minecraft.slime_ball": "sliz",
  "item.minecraft.chest_minecart": "vozík s truhlicou",
  "item.minecraft.furnace_minecart": "vozík s pecou",
  "item.minecraft.egg": "vajce",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "udica",
  "item.minecraft.clock": "hodinky",
  "item.minecraft.glowstone_dust": "svietivcový prach",
  "item.minecraft.cod": "surová treska",
  "item.minecraft.salmon": "surový losos",
  "item.minecraft.tropical_fish": "tropická ryba",
  "item.minecraft.pufferfish": "štvorzubec",
  "item.minecraft.cooked_cod": "pečená treska",
  "item.minecraft.cooked_salmon": "pečený losos",
  "item.minecraft.ink_sac": "atramentový váčok",
  "item.minecraft.red_dye": "červené farbivo",
  "item.minecraft.green_dye": "zelené farbivo",
  "item.minecraft.cocoa_beans": "kakaové bôby",
  "item.minecraft.lapis_lazuli": "lazurit",
  "item.minecraft.purple_dye": "fialové farbivo",
  "item.minecraft.cyan_dye": "tyrkysové farbivo",
  "item.minecraft.light_gray_dye": "svetlosivé farbivo",
  "item.minecraft.gray_dye": "sivé farbivo",
  "item.minecraft.pink_dye": "ružové farbivo",
  "item.minecraft.lime_dye": "svetlozelené farbivo",
  "item.minecraft.yellow_dye": "žlté farbivo",
  "item.minecraft.light_blue_dye": "svetlomodré farbivo",
  "item.minecraft.magenta_dye": "purpurové farbivo",
  "item.minecraft.orange_dye": "oranžové farbivo",
  "item.minecraft.bone_meal": "kostná múčka",
  "item.minecraft.blue_dye": "modré farbivo",
  "item.minecraft.brown_dye": "hnedé farbivo",
  "item.minecraft.black_dye": "čierne farbivo",
  "item.minecraft.white_dye": "biele farbivo",
  "item.minecraft.bone": "kosť",
  "item.minecraft.sugar": "cukor",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "biela posteľ",
  "block.minecraft.orange_bed": "oranžová posteľ",
  "block.minecraft.magenta_bed": "purpurová posteľ",
  "block.minecraft.light_blue_bed": "svetlomodrá posteľ",
  "block.minecraft.yellow_bed": "žltá posteľ",
  "block.minecraft.lime_bed": "svetlozelená posteľ",
  "block.minecraft.pink_bed": "ružová posteľ",
  "block.minecraft.gray_bed": "sivá posteľ",
  "block.minecraft.light_gray_bed": "svetlosivá posteľ",
  "block.minecraft.cyan_bed": "tyrkysová posteľ",
  "block.minecraft.purple_bed": "fialová posteľ",
  "block.minecraft.blue_bed": "modrá posteľ",
  "block.minecraft.brown_bed": "hnedá posteľ",
  "block.minecraft.green_bed": "zelená posteľ",
  "block.minecraft.red_bed": "červená posteľ",
  "block.minecraft.black_bed": "čierna posteľ",
  "item.minecraft.cookie": "sušienka",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "nožnice",
  "item.minecraft.melon_slice": "plátok melónu",
  "item.minecraft.dried_kelp": "sušená chaluha",
  "item.minecraft.pumpkin_seeds": "tekvicové semienka",
  "item.minecraft.melon_seeds": "melónové semienka",
  "item.minecraft.beef": "surové hovädzie",
  "item.minecraft.cooked_beef": "hovädzí rezeň",
  "item.minecraft.chicken": "surové kurča",
  "item.minecraft.cooked_chicken": "pečené kurča",
  "item.minecraft.rotten_flesh": "zhnité mäso",
  "item.minecraft.ender_pearl": "ender perla",
  "item.minecraft.blaze_rod": "tyč ohniváka",
  "item.minecraft.ghast_tear": "slza ghasta",
  "item.minecraft.gold_nugget": "zlatý nuget",
  "item.minecraft.nether_wart": "nether bradavica",
  "item.minecraft.potion": "nevytvoriteľný elixír□žiadne účinky",
  "item.minecraft.glass_bottle": "sklenená fľaša",
  "item.minecraft.spider_eye": "pavúčie oko",
  "item.minecraft.fermented_spider_eye": "kvasené pavúčie oko",
  "item.minecraft.blaze_powder": "prach ohniváka",
  "item.minecraft.magma_cream": "magmový krém",
  "block.minecraft.brewing_stand": "varný stojan",
  "block.minecraft.cauldron": "kotlík",
  "item.minecraft.ender_eye": "ender oko",
  "item.minecraft.glistering_melon_slice": "trblietavý melón",
  "item.minecraft.bat_spawn_egg": "vajíčko s netopierom",
  "item.minecraft.bee_spawn_egg": "vajíčko so včelou",
  "item.minecraft.blaze_spawn_egg": "vajíčko s ohnivákom",
  "item.minecraft.cat_spawn_egg": "vajíčko s mačkou",
  "item.minecraft.cave_spider_spawn_egg": "vajíčko s jaskynným pavúkom",
  "item.minecraft.chicken_spawn_egg": "vajíčko so sliepkou",
  "item.minecraft.cod_spawn_egg": "vajíčko s treskou",
  "item.minecraft.cow_spawn_egg": "vajíčko s kravou",
  "item.minecraft.creeper_spawn_egg": "vajíčko s creeperom",
  "item.minecraft.dolphin_spawn_egg": "vajíčko s delfínom",
  "item.minecraft.donkey_spawn_egg": "vajíčko so somárom",
  "item.minecraft.drowned_spawn_egg": "vajíčko s utopencom",
  "item.minecraft.elder_guardian_spawn_egg": "vajíčko s prastrážcom",
  "item.minecraft.enderman_spawn_egg": "vajíčko s endermanom",
  "item.minecraft.endermite_spawn_egg": "vajíčko s endermitom",
  "item.minecraft.evoker_spawn_egg": "vajíčko s vyvolávačom",
  "item.minecraft.fox_spawn_egg": "vajíčko s líškou",
  "item.minecraft.ghast_spawn_egg": "vajíčko s ghastom",
  "item.minecraft.guardian_spawn_egg": "vajíčko so strážcom",
  "item.minecraft.hoglin_spawn_egg": "vajíčko s hoglinom",
  "item.minecraft.horse_spawn_egg": "vajíčko s koňom",
  "item.minecraft.husk_spawn_egg": "vajíčko so zdochliakom",
  "item.minecraft.llama_spawn_egg": "vajíčko s lamou",
  "item.minecraft.magma_cube_spawn_egg": "vajíčko s magmovým slizákom",
  "item.minecraft.mooshroom_spawn_egg": "vajíčko s muchokrávkou",
  "item.minecraft.mule_spawn_egg": "vajíčko s mulicou",
  "item.minecraft.ocelot_spawn_egg": "vajíčko s ocelotom",
  "item.minecraft.panda_spawn_egg": "vajíčko s pandou",
  "item.minecraft.parrot_spawn_egg": "vajíčko s papagájom",
  "item.minecraft.phantom_spawn_egg": "vajíčko s prízrakom",
  "item.minecraft.pig_spawn_egg": "vajíčko s prasaťom",
  "item.minecraft.piglin_spawn_egg": "vajíčko s piglinom",
  "item.minecraft.pillager_spawn_egg": "vajíčko so zbojníkom",
  "item.minecraft.polar_bear_spawn_egg": "vajíčko s polárnym medveďom",
  "item.minecraft.pufferfish_spawn_egg": "vajíčko so štvorzubcom",
  "item.minecraft.rabbit_spawn_egg": "vajíčko s králikom",
  "item.minecraft.ravager_spawn_egg": "vajíčko s ničiteľom",
  "item.minecraft.salmon_spawn_egg": "vajíčko s lososom",
  "item.minecraft.sheep_spawn_egg": "vajíčko s ovcou",
  "item.minecraft.shulker_spawn_egg": "vajíčko so shulkerom",
  "item.minecraft.silverfish_spawn_egg": "vajíčko so švehlou",
  "item.minecraft.skeleton_spawn_egg": "vajíčko s kostlivcom",
  "item.minecraft.skeleton_horse_spawn_egg": "vajíčko s kostlivým koňom",
  "item.minecraft.slime_spawn_egg": "vajíčko so slizákom",
  "item.minecraft.spider_spawn_egg": "vajíčko s pavúkom",
  "item.minecraft.squid_spawn_egg": "vajíčko s chobotnicou",
  "item.minecraft.stray_spawn_egg": "vajíčko s tulákom",
  "item.minecraft.strider_spawn_egg": "vajíčko s lávochodom",
  "item.minecraft.trader_llama_spawn_egg": "vajíčko s obchodníckou lamou",
  "item.minecraft.tropical_fish_spawn_egg": "vajíčko s tropickou rybou",
  "item.minecraft.turtle_spawn_egg": "vajíčko s korytnačkou",
  "item.minecraft.vex_spawn_egg": "vajíčko so škodcom",
  "item.minecraft.villager_spawn_egg": "vajíčko s osadníkom",
  "item.minecraft.vindicator_spawn_egg": "vajíčko s pomstiteľom",
  "item.minecraft.wandering_trader_spawn_egg": "vajíčko s potulným obchodníkom",
  "item.minecraft.witch_spawn_egg": "vajíčko s bosorkou",
  "item.minecraft.wither_skeleton_spawn_egg": "vajíčko s wither kostlivcom",
  "item.minecraft.wolf_spawn_egg": "vajíčko s vlkom",
  "item.minecraft.zoglin_spawn_egg": "vajíčko so zoglinom",
  "item.minecraft.zombie_spawn_egg": "vajíčko so zombíkom",
  "item.minecraft.zombie_horse_spawn_egg": "vajíčko so zombie koňom",
  "item.minecraft.zombie_villager_spawn_egg": "vajíčko so zombie osadníkom",
  "item.minecraft.zombified_piglin_spawn_egg": "vajíčko so zombie piglinom",
  "item.minecraft.experience_bottle": "čarovná fľaša",
  "item.minecraft.fire_charge": "ohnivá strela",
  "item.minecraft.writable_book": "kniha a brko",
  "item.minecraft.written_book": "napísaná kniha",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rám",
  "block.minecraft.flower_pot": "kvetináč",
  "item.minecraft.carrot": "mrkva",
  "item.minecraft.potato": "zemiak",
  "item.minecraft.baked_potato": "pečený zemiak",
  "item.minecraft.poisonous_potato": "jedovatý zemiak",
  "item.minecraft.map": "prázdna mapa",
  "item.minecraft.golden_carrot": "zlatá mrkva",
  "block.minecraft.skeleton_skull": "lebka kostlivca",
  "block.minecraft.wither_skeleton_skull": "lebka wither kostlivca",
  "block.minecraft.player_head": "hlava hráča",
  "block.minecraft.zombie_head": "hlava zombíka",
  "block.minecraft.creeper_head": "hlava creepera",
  "block.minecraft.dragon_head": "dračia hlava",
  "item.minecraft.carrot_on_a_stick": "mrkva na udici",
  "item.minecraft.warped_fungus_on_a_stick": "prízračná huba na udici",
  "item.minecraft.nether_star": "nether hviezda",
  "item.minecraft.pumpkin_pie": "tekvicový koláč",
  "item.minecraft.firework_rocket": "ohňostroj",
  "item.minecraft.firework_star": "ohňostrojová hviezda",
  "item.minecraft.enchanted_book": "očarovaná kniha",
  "item.minecraft.nether_brick": "nether tehla",
  "item.minecraft.quartz": "nether kremeň",
  "item.minecraft.tnt_minecart": "vozík s tnt",
  "item.minecraft.hopper_minecart": "vozík s násypníkom",
  "item.minecraft.prismarine_shard": "prizmarínový črep",
  "item.minecraft.prismarine_crystals": "prizmarínové kryštály",
  "item.minecraft.rabbit": "surový králik",
  "item.minecraft.cooked_rabbit": "pečený králik",
  "item.minecraft.rabbit_stew": "králičí guláš",
  "item.minecraft.rabbit_foot": "králičia labka",
  "item.minecraft.rabbit_hide": "králičia koža",
  "item.minecraft.armor_stand": "stojan na brnenie",
  "item.minecraft.iron_horse_armor": "železná konská zbroj",
  "item.minecraft.golden_horse_armor": "zlatá konská zbroj",
  "item.minecraft.diamond_horse_armor": "diamantová konská zbroj",
  "item.minecraft.leather_horse_armor": "kožená konská zbroj",
  "item.minecraft.lead": "vôdzka",
  "item.minecraft.name_tag": "menovka",
  "item.minecraft.command_block_minecart": "vozík s príkazovou kockou",
  "item.minecraft.mutton": "surová baranina",
  "item.minecraft.cooked_mutton": "pečená baranina",
  "block.minecraft.white_banner": "biela zástava",
  "block.minecraft.orange_banner": "oranžová zástava",
  "block.minecraft.magenta_banner": "purpurová zástava",
  "block.minecraft.light_blue_banner": "svetlomodrá zástava",
  "block.minecraft.yellow_banner": "žltá zástava",
  "block.minecraft.lime_banner": "svetlozelená zástava",
  "block.minecraft.pink_banner": "ružová zástava",
  "block.minecraft.gray_banner": "sivá zástava",
  "block.minecraft.light_gray_banner": "svetlosivá zástava",
  "block.minecraft.cyan_banner": "tyrkysová zástava",
  "block.minecraft.purple_banner": "fialová zástava",
  "block.minecraft.blue_banner": "modrá zástava",
  "block.minecraft.brown_banner": "hnedá zástava",
  "block.minecraft.green_banner": "zelená zástava",
  "block.minecraft.red_banner": "červená zástava",
  "block.minecraft.black_banner": "čierna zástava",
  "item.minecraft.end_crystal": "endový kryštál",
  "item.minecraft.chorus_fruit": "chorus",
  "item.minecraft.popped_chorus_fruit": "vyklíčený chorus",
  "item.minecraft.beetroot": "repa",
  "item.minecraft.beetroot_seeds": "semienka repy",
  "item.minecraft.beetroot_soup": "boršč",
  "item.minecraft.dragon_breath": "dračí dych",
  "item.minecraft.splash_potion": "hádzací nevytvoriteľný elixír□žiadne účinky",
  "item.minecraft.spectral_arrow": "žiariaci šíp",
  "item.minecraft.tipped_arrow": "nevyrobiteľný šíp s efektom□žiadne účinky",
  "item.minecraft.lingering_potion": "plynný nevytvoriteľný elixír□žiadne účinky",
  "item.minecraft.shield": "štít",
  "item.minecraft.elytra": "krovky",
  "item.minecraft.spruce_boat": "smrekový čln",
  "item.minecraft.birch_boat": "brezový čln",
  "item.minecraft.jungle_boat": "džungľový čln",
  "item.minecraft.acacia_boat": "akáciový čln",
  "item.minecraft.dark_oak_boat": "čln z tmavého dubu",
  "item.minecraft.totem_of_undying": "totem nesmrteľnosti",
  "item.minecraft.shulker_shell": "shulkerov pancier",
  "item.minecraft.iron_nugget": "železný nuget",
  "item.minecraft.knowledge_book": "kniha znalostí",
  "item.minecraft.debug_stick": "ladiaca palica",
  "item.minecraft.music_disc_13": "hudobná platňa□c418 - 13",
  "item.minecraft.music_disc_cat": "hudobná platňa□c418 - cat",
  "item.minecraft.music_disc_blocks": "hudobná platňa□c418 - blocks",
  "item.minecraft.music_disc_chirp": "hudobná platňa□c418 - chirp",
  "item.minecraft.music_disc_far": "hudobná platňa□c418 - far",
  "item.minecraft.music_disc_mall": "hudobná platňa□c418 - mall",
  "item.minecraft.music_disc_mellohi": "hudobná platňa□c418 - mellohi",
  "item.minecraft.music_disc_stal": "hudobná platňa□c418 - stal",
  "item.minecraft.music_disc_strad": "hudobná platňa□c418 - strad",
  "item.minecraft.music_disc_ward": "hudobná platňa□c418 - ward",
  "item.minecraft.music_disc_11": "hudobná platňa□c418 - 11",
  "item.minecraft.music_disc_wait": "hudobná platňa□c418 - wait",
  "item.minecraft.music_disc_pigstep": "hudobná platňa□lena raine - pigstep",
  "item.minecraft.trident": "trojzubec□□v hlavnej ruke:□+8 sila útoku□–2.9 rýchlosť útoku",
  "item.minecraft.phantom_membrane": "koža prízraku",
  "item.minecraft.nautilus_shell": "ulita lodienky",
  "item.minecraft.heart_of_the_sea": "srdce oceánu",
  "item.minecraft.crossbow": "kuša",
  "item.minecraft.suspicious_stew": "podozrivá brečka",
  "block.minecraft.loom": "krosná",
  "item.minecraft.flower_banner_pattern": "vzor zástavy□kvet",
  "item.minecraft.creeper_banner_pattern": "vzor zástavy□creeper",
  "item.minecraft.skull_banner_pattern": "vzor zástavy□lebka",
  "item.minecraft.mojang_banner_pattern": "vzor zástavy□vecička",
  "item.minecraft.globe_banner_pattern": "vzor zástavy□glóbus",
  "item.minecraft.piglin_banner_pattern": "vzor zástavy□rypák",
  "block.minecraft.composter": "kompostér",
  "block.minecraft.barrel": "sud",
  "block.minecraft.smoker": "udiareň",
  "block.minecraft.blast_furnace": "tavná pec",
  "block.minecraft.cartography_table": "kartografický stôl",
  "block.minecraft.fletching_table": "stôl na výrobu šípov",
  "block.minecraft.grindstone": "brúsny kameň",
  "block.minecraft.lectern": "pult na čítanie",
  "block.minecraft.smithing_table": "kováčsky stôl",
  "block.minecraft.stonecutter": "píla na kameň",
  "block.minecraft.bell": "zvon",
  "block.minecraft.lantern": "lampáš",
  "block.minecraft.soul_lantern": "lampáš s ohňom duší",
  "item.minecraft.sweet_berries": "sladké bobule",
  "block.minecraft.campfire": "táborák",
  "block.minecraft.soul_campfire": "táborák s ohňom duší",
  "block.minecraft.shroomlight": "lampiňón",
  "item.minecraft.honeycomb": "medový plást",
  "block.minecraft.bee_nest": "včelie hniezdo",
  "block.minecraft.beehive": "včelí úľ",
  "item.minecraft.honey_bottle": "fľaša medu",
  "block.minecraft.honey_block": "kocka medu",
  "block.minecraft.honeycomb_block": "kocka medového plástu",
  "block.minecraft.lodestone": "navigačný kameň",
  "block.minecraft.netherite_block": "kocka netheritu",
  "block.minecraft.ancient_debris": "starobylé trosky",
  "block.minecraft.target": "terč",
  "block.minecraft.crying_obsidian": "slziaci obsidián",
  "block.minecraft.blackstone": "čierny kameň",
  "block.minecraft.blackstone_slab": "stupienok z čierneho kameňa",
  "block.minecraft.blackstone_stairs": "schody z čierneho kameňa",
  "block.minecraft.gilded_blackstone": "pozlátený čierny kameň",
  "block.minecraft.polished_blackstone": "leštený čierny kameň",
  "block.minecraft.polished_blackstone_slab": "stupienok z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_stairs": "schody z lešteného čierneho kameňa",
  "block.minecraft.chiseled_polished_blackstone": "otesaný leštený čierny kameň",
  "block.minecraft.polished_blackstone_bricks": "tehly z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_brick_slab": "stupienok z tehál z lešteného čierneho kameňa",
  "block.minecraft.polished_blackstone_brick_stairs": "schody z tehál z lešteného čierneho kameňa",
  "block.minecraft.cracked_polished_blackstone_bricks": "popraskané tehly z lešteného čierneho kameňa",
  "block.minecraft.respawn_anchor": "kotva oživenia",
}
export const sk_sk = items; 
